import caveSource from "./void-cave-source.json";

const TILE_SIZE = Number(caveSource.tilewidth || 32);
const FALLBACK_LOWER_ENTRANCE = Object.freeze({
  x: 192,
  y: 448,
  width: 96,
  height: 64,
});

const navigationObjects =
  caveSource.layers.find(
    (layer) => layer.type === "objectgroup" && layer.name === "Navigation",
  )?.objects || [];

const normalizeRect = (object, fallback = null) => {
  if (!object) return fallback;
  return Object.freeze({
    x: Number(object.x || 0),
    y: Number(object.y || 0),
    width: Number(object.width || 0),
    height: Number(object.height || 0),
  });
};

export const VOID_CAVE_LOWER_ENTRANCE_RECT = normalizeRect(
  navigationObjects.find((object) => object.name === "lowerEntrance"),
  FALLBACK_LOWER_ENTRANCE,
);

const FALLBACK_UPPER_DOOR = Object.freeze({
  x: 608,
  y: 96,
  width: 96,
  height: 64,
});

export const VOID_CAVE_UPPER_DOOR_RECT = normalizeRect(
  navigationObjects.find((object) => object.name === "upperDoor"),
  FALLBACK_UPPER_DOOR,
);

export const VOID_CAVE_UPPER_DOOR_RETURN_SPAWN = Object.freeze({
  x: VOID_CAVE_UPPER_DOOR_RECT.x + VOID_CAVE_UPPER_DOOR_RECT.width / 2,
  y:
    VOID_CAVE_UPPER_DOOR_RECT.y +
    VOID_CAVE_UPPER_DOOR_RECT.height +
    TILE_SIZE / 2,
});

export const VOID_CAVE_BRIDGE_RECTS = Object.freeze(
  navigationObjects
    .filter((object) => object.type === "bridge")
    .map((object) => normalizeRect(object)),
);

export const VOID_CAVE_ENTRY_SPAWN = Object.freeze({
  x:
    VOID_CAVE_LOWER_ENTRANCE_RECT.x +
    VOID_CAVE_LOWER_ENTRANCE_RECT.width / 2 +
    TILE_SIZE / 2,
  y:
    VOID_CAVE_LOWER_ENTRANCE_RECT.y +
    VOID_CAVE_LOWER_ENTRANCE_RECT.height +
    TILE_SIZE * 1.5,
});

const rectanglesOverlap = (left, right) =>
  left.x < right.x + right.width &&
  left.x + left.width > right.x &&
  left.y < right.y + right.height &&
  left.y + left.height > right.y;

export const isVoidCaveNavigationTileWalkable = (tileX, tileY) => {
  const tileRect = {
    x: Number(tileX) * TILE_SIZE,
    y: Number(tileY) * TILE_SIZE,
    width: TILE_SIZE,
    height: TILE_SIZE,
  };

  return [VOID_CAVE_LOWER_ENTRANCE_RECT, ...VOID_CAVE_BRIDGE_RECTS].some(
    (rect) => rectanglesOverlap(tileRect, rect),
  );
};

export const isVoidCaveBridgePoint = (x, y) =>
  VOID_CAVE_BRIDGE_RECTS.some(
    (rect) =>
      Number(x) >= rect.x &&
      Number(x) <= rect.x + rect.width &&
      Number(y) >= rect.y &&
      Number(y) <= rect.y + rect.height,
  );
